// Profile page translations
export const profileTranslations = {
  en: {
    "title": "Profile",
    "sections": {
      "personalInfo": "Personal Information",
      "security": "Security Settings",
      "preferences": "Preferences"
    },
    "fields": {
      "username": "Username",
      "email": "Email",
      "joinDate": "Join Date",
      "lastLogin": "Last Login",
      "language": "Preferred Language",
      "currentPassword": "Current Password",
      "newPassword": "New Password",
      "confirmNewPassword": "Confirm New Password"
    },
    "actions": {
      "updateProfile": "Update Profile",
      "changePassword": "Change Password",
      "deleteAccount": "Delete Account"
    },
    "mfa": {
      "title": "Two-Factor Authentication",
      "description": "Require a one-time code emailed to you each time you log in.",
      "on": "Enabled (email code)",
      "off": "Disabled",
      "enableTitle": "Turn on two-factor authentication?",
      "disableTitle": "Turn off two-factor authentication?",
      "confirmPrompt": "Enter your current password to confirm this change.",
      "cancel": "Cancel",
      "confirm": "Confirm",
      "saving": "Saving...",
      "enabledMsg": "Two-factor authentication is now on.",
      "disabledMsg": "Two-factor authentication is now off.",
      "error": "Could not update two-factor settings."
    },
    "messages": {
      "updateSuccess": "Profile updated successfully",
      "updateError": "Profile update failed",
      "passwordChangeSuccess": "Password changed successfully",
      "passwordChangeError": "Failed to change password"
    }
  },
  zh: {
    "title": "个人资料",
    "sections": {
      "personalInfo": "个人信息",
      "security": "安全设置",
      "preferences": "偏好设置"
    },
    "fields": {
      "username": "用户名",
      "email": "电子邮箱",
      "joinDate": "加入日期",
      "lastLogin": "最后登录",
      "language": "首选语言",
      "currentPassword": "当前密码",
      "newPassword": "新密码",
      "confirmNewPassword": "确认新密码"
    },
    "actions": {
      "updateProfile": "更新资料",
      "changePassword": "修改密码",
      "deleteAccount": "删除账号"
    },
    "mfa": {
      "title": "两步验证",
      "description": "每次登录时要求输入发送到您邮箱的一次性验证码。",
      "on": "已启用（邮件验证码）",
      "off": "已禁用",
      "enableTitle": "开启两步验证？",
      "disableTitle": "关闭两步验证？",
      "confirmPrompt": "请输入当前密码以确认此更改。",
      "cancel": "取消",
      "confirm": "确认",
      "saving": "保存中...",
      "enabledMsg": "两步验证已开启。",
      "disabledMsg": "两步验证已关闭。",
      "error": "无法更新两步验证设置。"
    },
    "messages": {
      "updateSuccess": "资料更新成功",
      "updateError": "资料更新失败",
      "passwordChangeSuccess": "密码修改成功",
      "passwordChangeError": "密码修改失败"
    }
  },
  fr: {
    "title": "Profil",
    "sections": {
      "personalInfo": "Informations personnelles",
      "security": "Paramètres de sécurité",
      "preferences": "Préférences"
    },
    "fields": {
      "username": "Nom d'utilisateur",
      "email": "Adresse e-mail",
      "joinDate": "Date d'adhésion",
      "lastLogin": "Dernière connexion",
      "language": "Langue préférée",
      "currentPassword": "Mot de passe actuel",
      "newPassword": "Nouveau mot de passe",
      "confirmNewPassword": "Confirmer le nouveau mot de passe"
    },
    "actions": {
      "updateProfile": "Mettre à jour le profil",
      "changePassword": "Modifier le mot de passe",
      "deleteAccount": "Supprimer le compte"
    },
    "mfa": {
      "title": "Authentification à deux facteurs",
      "description": "Exiger un code à usage unique envoyé par e-mail à chaque connexion.",
      "on": "Activée (code par e-mail)",
      "off": "Désactivée",
      "enableTitle": "Activer l'authentification à deux facteurs ?",
      "disableTitle": "Désactiver l'authentification à deux facteurs ?",
      "confirmPrompt": "Saisissez votre mot de passe actuel pour confirmer ce changement.",
      "cancel": "Annuler",
      "confirm": "Confirmer",
      "saving": "Enregistrement...",
      "enabledMsg": "L'authentification à deux facteurs est maintenant activée.",
      "disabledMsg": "L'authentification à deux facteurs est maintenant désactivée.",
      "error": "Impossible de mettre à jour les paramètres d'authentification à deux facteurs."
    },
    "messages": {
      "updateSuccess": "Profil mis à jour avec succès",
      "updateError": "Échec de la mise à jour du profil",
      "passwordChangeSuccess": "Mot de passe modifié avec succès",
      "passwordChangeError": "Échec de la modification du mot de passe"
    }
  },
  nb: {
    "title": "Profil",
    "sections": {
      "personalInfo": "Personlig informasjon",
      "security": "Sikkerhetsinnstillinger",
      "preferences": "Preferanser"
    },
    "fields": {
      "username": "Brukernavn",
      "email": "E-post",
      "joinDate": "Registreringsdato",
      "lastLogin": "Siste innlogging",
      "language": "Foretrukket språk",
      "currentPassword": "Nåværende passord",
      "newPassword": "Nytt passord",
      "confirmNewPassword": "Bekreft nytt passord"
    },
    "actions": {
      "updateProfile": "Oppdater profil",
      "changePassword": "Endre passord",
      "deleteAccount": "Slett konto"
    },
    "mfa": {
      "title": "Tofaktorautentisering",
      "description": "Krev en engangskode på e-post hver gang du logger inn.",
      "on": "Aktivert (e-postkode)",
      "off": "Deaktivert",
      "enableTitle": "Slå på tofaktorautentisering?",
      "disableTitle": "Slå av tofaktorautentisering?",
      "confirmPrompt": "Skriv inn ditt nåværende passord for å bekrefte denne endringen.",
      "cancel": "Avbryt",
      "confirm": "Bekreft",
      "saving": "Lagrer...",
      "enabledMsg": "Tofaktorautentisering er nå på.",
      "disabledMsg": "Tofaktorautentisering er nå av.",
      "error": "Kunne ikke oppdatere tofaktorinnstillingene."
    },
    "messages": {
      "updateSuccess": "Profil oppdatert",
      "updateError": "Kunne ikke oppdatere profil",
      "passwordChangeSuccess": "Passord endret",
      "passwordChangeError": "Kunne ikke endre passord"
    }
  },
  nl: {
    "title": "Profiel",
    "sections": {
      "personalInfo": "Persoonlijke Informatie",
      "security": "Beveiligingsinstellingen",
      "preferences": "Voorkeuren"
    },
    "fields": {
      "username": "Gebruikersnaam",
      "email": "E-mail",
      "joinDate": "Registratiedatum",
      "lastLogin": "Laatste Inlog",
      "language": "Voorkeurstaal",
      "currentPassword": "Huidig Wachtwoord",
      "newPassword": "Nieuw Wachtwoord",
      "confirmNewPassword": "Nieuw Wachtwoord Bevestigen"
    },
    "actions": {
      "updateProfile": "Profiel Bijwerken",
      "changePassword": "Wachtwoord Wijzigen",
      "deleteAccount": "Account Verwijderen"
    },
    "mfa": {
      "title": "Tweefactorauthenticatie",
      "description": "Vereis bij elke aanmelding een eenmalige code die naar je wordt gemaild.",
      "on": "Ingeschakeld (e-mailcode)",
      "off": "Uitgeschakeld",
      "enableTitle": "Tweefactorauthenticatie inschakelen?",
      "disableTitle": "Tweefactorauthenticatie uitschakelen?",
      "confirmPrompt": "Voer je huidige wachtwoord in om deze wijziging te bevestigen.",
      "cancel": "Annuleren",
      "confirm": "Bevestigen",
      "saving": "Opslaan...",
      "enabledMsg": "Tweefactorauthenticatie staat nu aan.",
      "disabledMsg": "Tweefactorauthenticatie staat nu uit.",
      "error": "Kan tweefactorinstellingen niet bijwerken."
    },
    "messages": {
      "updateSuccess": "Profiel succesvol bijgewerkt",
      "updateError": "Profiel bijwerken mislukt",
      "passwordChangeSuccess": "Wachtwoord succesvol gewijzigd",
      "passwordChangeError": "Wachtwoord wijzigen mislukt"
    }
  },
  de: {
    "title": "Profil",
    "sections": {
      "personalInfo": "Persönliche Informationen",
      "security": "Sicherheitseinstellungen",
      "preferences": "Einstellungen"
    },
    "fields": {
      "username": "Benutzername",
      "email": "E-Mail",
      "joinDate": "Beitrittsdatum",
      "lastLogin": "Letzte Anmeldung",
      "language": "Bevorzugte Sprache",
      "currentPassword": "Aktuelles Passwort",
      "newPassword": "Neues Passwort",
      "confirmNewPassword": "Neues Passwort bestätigen"
    },
    "actions": {
      "updateProfile": "Profil aktualisieren",
      "changePassword": "Passwort ändern",
      "deleteAccount": "Konto löschen"
    },
    "mfa": {
      "title": "Zwei-Faktor-Authentifizierung",
      "description": "Bei jeder Anmeldung einen per E-Mail gesendeten Einmalcode verlangen.",
      "on": "Aktiviert (E-Mail-Code)",
      "off": "Deaktiviert",
      "enableTitle": "Zwei-Faktor-Authentifizierung aktivieren?",
      "disableTitle": "Zwei-Faktor-Authentifizierung deaktivieren?",
      "confirmPrompt": "Geben Sie Ihr aktuelles Passwort ein, um diese Änderung zu bestätigen.",
      "cancel": "Abbrechen",
      "confirm": "Bestätigen",
      "saving": "Wird gespeichert...",
      "enabledMsg": "Die Zwei-Faktor-Authentifizierung ist jetzt aktiviert.",
      "disabledMsg": "Die Zwei-Faktor-Authentifizierung ist jetzt deaktiviert.",
      "error": "Zwei-Faktor-Einstellungen konnten nicht aktualisiert werden."
    },
    "messages": {
      "updateSuccess": "Profil erfolgreich aktualisiert",
      "updateError": "Profilaktualisierung fehlgeschlagen",
      "passwordChangeSuccess": "Passwort erfolgreich geändert",
      "passwordChangeError": "Passwort konnte nicht geändert werden"
    }
  },
  es: {
    "title": "Perfil",
    "sections": {
      "personalInfo": "Información personal",
      "security": "Configuración de seguridad",
      "preferences": "Preferencias"
    },
    "fields": {
      "username": "Nombre de usuario",
      "email": "Correo electrónico",
      "joinDate": "Fecha de registro",
      "lastLogin": "Último acceso",
      "language": "Idioma preferido",
      "currentPassword": "Contraseña actual",
      "newPassword": "Nueva contraseña",
      "confirmNewPassword": "Confirmar nueva contraseña"
    },
    "actions": {
      "updateProfile": "Actualizar perfil",
      "changePassword": "Cambiar contraseña",
      "deleteAccount": "Eliminar cuenta"
    },
    "mfa": {
      "title": "Autenticación de dos factores",
      "description": "Requiere un código de un solo uso enviado por correo cada vez que inicias sesión.",
      "on": "Activada (código por correo)",
      "off": "Desactivada",
      "enableTitle": "¿Activar la autenticación de dos factores?",
      "disableTitle": "¿Desactivar la autenticación de dos factores?",
      "confirmPrompt": "Introduce tu contraseña actual para confirmar este cambio.",
      "cancel": "Cancelar",
      "confirm": "Confirmar",
      "saving": "Guardando...",
      "enabledMsg": "La autenticación de dos factores está activada.",
      "disabledMsg": "La autenticación de dos factores está desactivada.",
      "error": "No se pudo actualizar la configuración de dos factores."
    },
    "messages": {
      "updateSuccess": "Perfil actualizado con éxito",
      "updateError": "Error al actualizar el perfil",
      "passwordChangeSuccess": "Contraseña cambiada con éxito",
      "passwordChangeError": "Error al cambiar la contraseña"
    }
  },
  pt: {
    "title": "Perfil",
    "sections": {
      "personalInfo": "Informações pessoais",
      "security": "Configurações de segurança",
      "preferences": "Preferências"
    },
    "fields": {
      "username": "Nome de usuário",
      "email": "E-mail",
      "joinDate": "Data de registro",
      "lastLogin": "Último acesso",
      "language": "Idioma preferido",
      "currentPassword": "Senha atual",
      "newPassword": "Nova senha",
      "confirmNewPassword": "Confirmar nova senha"
    },
    "actions": {
      "updateProfile": "Atualizar perfil",
      "changePassword": "Alterar senha",
      "deleteAccount": "Excluir conta"
    },
    "mfa": {
      "title": "Autenticação de dois fatores",
      "description": "Exigir um código de utilização única enviado por e-mail sempre que iniciar sessão.",
      "on": "Ativada (código por e-mail)",
      "off": "Desativada",
      "enableTitle": "Ativar a autenticação de dois fatores?",
      "disableTitle": "Desativar a autenticação de dois fatores?",
      "confirmPrompt": "Introduza a sua palavra-passe atual para confirmar esta alteração.",
      "cancel": "Cancelar",
      "confirm": "Confirmar",
      "saving": "A guardar...",
      "enabledMsg": "A autenticação de dois fatores está agora ativada.",
      "disabledMsg": "A autenticação de dois fatores está agora desativada.",
      "error": "Não foi possível atualizar as definições de dois fatores."
    },
    "messages": {
      "updateSuccess": "Perfil atualizado com sucesso",
      "updateError": "Erro ao atualizar perfil",
      "passwordChangeSuccess": "Senha alterada com sucesso",
      "passwordChangeError": "Erro ao alterar senha"
    }
  },
  ja: {
    "title": "プロフィール",
    "sections": {
      "personalInfo": "個人情報",
      "security": "セキュリティ設定",
      "preferences": "設定"
    },
    "fields": {
      "username": "ユーザー名",
      "email": "メールアドレス",
      "joinDate": "登録日",
      "lastLogin": "最終ログイン",
      "language": "優先言語",
      "currentPassword": "現在のパスワード",
      "newPassword": "新しいパスワード",
      "confirmNewPassword": "新しいパスワードを確認"
    },
    "actions": {
      "updateProfile": "プロフィールを更新",
      "changePassword": "パスワードを変更",
      "deleteAccount": "アカウントを削除"
    },
    "mfa": {
      "title": "二段階認証",
      "description": "ログインのたびにメールで送信されるワンタイムコードを要求します。",
      "on": "有効（メールコード）",
      "off": "無効",
      "enableTitle": "二段階認証を有効にしますか？",
      "disableTitle": "二段階認証を無効にしますか？",
      "confirmPrompt": "この変更を確認するには現在のパスワードを入力してください。",
      "cancel": "キャンセル",
      "confirm": "確認",
      "saving": "保存中...",
      "enabledMsg": "二段階認証が有効になりました。",
      "disabledMsg": "二段階認証が無効になりました。",
      "error": "二段階認証の設定を更新できませんでした。"
    },
    "messages": {
      "updateSuccess": "プロフィールが正常に更新されました",
      "updateError": "プロフィールの更新に失敗しました",
      "passwordChangeSuccess": "パスワードが正常に変更されました",
      "passwordChangeError": "パスワードの変更に失敗しました"
    }
  },
  ar: {
    "title": "الملف الشخصي",
    "sections": {
      "personalInfo": "المعلومات الشخصية",
      "security": "إعدادات الأمان",
      "preferences": "التفضيلات"
    },
    "fields": {
      "username": "اسم المستخدم",
      "email": "البريد الإلكتروني",
      "joinDate": "تاريخ التسجيل",
      "lastLogin": "آخر تسجيل دخول",
      "language": "اللغة المفضلة",
      "currentPassword": "كلمة المرور الحالية",
      "newPassword": "كلمة المرور الجديدة",
      "confirmNewPassword": "تأكيد كلمة المرور الجديدة"
    },
    "actions": {
      "updateProfile": "تحديث الملف الشخصي",
      "changePassword": "تغيير كلمة المرور",
      "deleteAccount": "حذف الحساب"
    },
    "mfa": {
      "title": "المصادقة الثنائية",
      "description": "طلب رمز لمرة واحدة يُرسَل إلى بريدك الإلكتروني في كل مرة تسجّل فيها الدخول.",
      "on": "مُفعّلة (رمز عبر البريد)",
      "off": "مُعطّلة",
      "enableTitle": "تفعيل المصادقة الثنائية؟",
      "disableTitle": "تعطيل المصادقة الثنائية؟",
      "confirmPrompt": "أدخل كلمة المرور الحالية لتأكيد هذا التغيير.",
      "cancel": "إلغاء",
      "confirm": "تأكيد",
      "saving": "جارٍ الحفظ...",
      "enabledMsg": "تم تفعيل المصادقة الثنائية الآن.",
      "disabledMsg": "تم تعطيل المصادقة الثنائية الآن.",
      "error": "تعذّر تحديث إعدادات المصادقة الثنائية."
    },
    "messages": {
      "updateSuccess": "تم تحديث الملف الشخصي بنجاح",
      "updateError": "فشل في تحديث الملف الشخصي",
      "passwordChangeSuccess": "تم تغيير كلمة المرور بنجاح",
      "passwordChangeError": "فشل في تغيير كلمة المرور"
    }
  }
};
